export const getIsArraysEqual = (arr1: string[] = [], arr2: string[] = []) => {
  return (
    arr1.reduce((a, b) => a && arr2.includes(b), true) &&
    arr1.length === arr2.length
  );
};

type AirtableProps = {
  width: string | number | null;
  height: string | number | null;
  src: string | null;
};

export const getAirtablePropsFromIframe = (
  airtableCode: string | null | undefined
): AirtableProps => {
  if (airtableCode) {
    const srcMatch = airtableCode.match(/src="([^"]*)"/);
    const widthMatch = airtableCode.match(/width="([^"]*)"/);
    const heightMatch = airtableCode.match(/height="([^"]*)"/);

    const src = srcMatch && srcMatch[1] ? srcMatch[1] : null;
    const width = widthMatch && widthMatch[1] ? widthMatch[1] : null;
    const height = heightMatch && heightMatch[1] ? heightMatch[1] : null;

    return { width, height, src };
  }

  return { width: null, height: null, src: null };
};

export * from "./handleBriefingCardTracking";
